import Reserve from '../../components/Reserve/Reserve';

function ReservePage() {
  return <Reserve />;
}

export default ReservePage;
